module.exports = __webpack_public_path__ + "static/media/Flaticon.0917889d.svg";